import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const NewsPostListSearchParamsSchema = createPaginationSchema().concat(
  createSortSchema(['name', 'isPublished', 'lastPublishedAt'])
);
